import { createFileRoute } from '@tanstack/react-router';
import { FichaItemPage, lerBuscaFicha } from '@/components/ficha-tecnica';

export const Route = createFileRoute('/_app/custos/fichas-tecnicas/')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaFicha(bruto),
  component: FichaEntradaRota,
});

function FichaEntradaRota() {
  const busca = Route.useSearch();
  const { itemId } = busca;
  return <FichaItemPage key={itemId ?? 'sem-item'} {...(itemId ? { itemId } : {})} busca={busca} />;
}
